import { render, staticRenderFns } from "./ManyAttemps.vue?vue&type=template&id=5aa4f27c&scoped=true&"
import script from "./ManyAttemps.vue?vue&type=script&lang=js&"
export * from "./ManyAttemps.vue?vue&type=script&lang=js&"
import style0 from "./ManyAttemps.vue?vue&type=style&index=0&id=5aa4f27c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa4f27c",
  null
  
)

export default component.exports